import { px } from '@adsk/alloy-react-helpers';

import { AlloyLegacyThemeDesignTokens, FormFieldDesignTokens } from '../types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getFormFieldTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): FormFieldDesignTokens => ({
  label: {
    _: {
      color: theme.tokens.colors.text.secondary.value,
      display: 'flex',
    },
    side: {
      'margin-right': px(theme.spacing.XXS),
      'margin-top': px(theme.spacing.XS),
      'font-family': theme.typography.labelMedium.fontFamily,
      'font-weight': String(theme.typography.labelMedium.fontWeight),
      'font-size': theme.typography.labelMedium.fontSize,
      'line-height': theme.typography.labelMedium.lineHeight,
    },
    top: {
      'margin-bottom': px(theme.spacing.XS),
      'font-family': theme.typography.labelSmall.fontFamily,
      'font-weight': String(theme.typography.labelSmall.fontWeight),
      'font-size': theme.typography.labelSmall.fontSize,
      'line-height': theme.typography.labelSmall.lineHeight,
    },
  },
  required: {
    color: theme.tokens.colors.icon.error.value,
    'margin-left': px(3),
  },
  alertIcon: {
    'flex-shrink': '0',
    'margin-top': px(theme.spacing.XXXS),
    color: theme.tokens.colors.icon.error.value,
  },
  error: {
    text: {
      color: theme.tokens.colors.text.error.value,
      'font-size': px(12),
      'margin-left': px(theme.spacing.XS),
    },
    container: {
      display: 'flex',
      'margin-top': px(theme.spacing.XXS),
      'margin-bottom': px(theme.spacing.XXS),
    },
    tooltip: {
      'margin-left': px(theme.spacing.XXS),
      color: theme.tokens.colors.icon.error.value,
      flex: '0 0 auto',
      display: 'flex',
      'align-items': 'center',
    },
  },
  infoPopover: {
    'margin-top': px(theme.spacing.XXXS),
    'margin-left': px(5),
    height: px(16),
  },
});

export const getFormFieldTokensWeave = (
  tokens: WeaveTokens,
  fontFamily: string,
): FormFieldDesignTokens => {
  const input = tokens?.component?.input;
  const generic = tokens?.generic;
  const semantic = tokens?.semantic;
  const errorColor = semantic?.['status-color']?.error;

  return {
    label: {
      _: {
        color: generic?.color?.charcoal?.[700]?.[100],
        display: 'flex',
      },
      side: {
        'margin-right': generic?.spacing?.[4],
        'margin-top': generic?.spacing?.[8],
        'font-family': fontFamily,
        'font-weight': input?.['font-weight'],
        'font-size': input?.['font-size'],
        'line-height': input?.['line-height'],
      },
      top: {
        'margin-bottom': generic?.spacing?.[8],
        'font-family': fontFamily,
        'font-weight': input?.['font-weight'],
        'font-size': px(12),
        'line-height': px(16),
      },
    },
    required: {
      color: errorColor,
    },
    alertIcon: {
      color: errorColor,
      'margin-top': generic?.spacing?.[2],
    },
    error: {
      text: {
        color: errorColor,
        'font-size': px(12),
        'margin-left': generic?.spacing?.[8],
      },
      container: {
        display: 'flex',
        'margin-top': generic?.spacing?.[4],
        'margin-bottom': generic?.spacing?.[4],
      },
      tooltip: {
        'margin-left': generic?.spacing?.[4],
        color: errorColor,
      },
    },
    infoPopover: {
      'margin-top': generic?.spacing?.[2],
      'margin-left': generic?.spacing?.[4],
      height: px(16),
    },
  };
};
